import { render, staticRenderFns } from "./QuickBar.vue?vue&type=template&id=97572b42&scoped=true&"
import script from "./QuickBar.vue?vue&type=script&lang=js&"
export * from "./QuickBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97572b42",
  null
  
)

export default component.exports